import React from 'react';
import {ListItem, Footer as DeereFooter, List, FooterLink} from '@deere/ux.uxframe-react';

export default function Footer() {
    return (
        <>
            <DeereFooter className="d-print-none">
                <List className='nav'>
                    <ListItem>
                        <FooterLink href='https://jdsn.deere.com'> {'Home'} </FooterLink>
                    </ListItem>
                    <ListItem>
                        <FooterLink
                            href='http://www.deere.com/suppliercode'
                            rel='noopener noreferrer'
                            target='_blank'
                        >{'Supplier Code of Conduct'}</FooterLink>
                    </ListItem>
                    <ListItem>
                        <FooterLink
                            href='https://www.deere.com/en/privacy-and-data/'
                            rel='noopener noreferrer'
                            target='_blank'
                        >{'Privacy & Data'}
                        </FooterLink>
                    </ListItem>
                    <ListItem>
                        <FooterLink
                            href='https://www.deere.com/en/privacy-and-data/terms/'
                            rel='noopener noreferrer'
                            target='_blank'
                        >{'Terms of Use'}
                        </FooterLink>
                    </ListItem>
                </List>
            </DeereFooter>
        </>
    );
}